import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';

export const downloadExcel = (jsonData, fileName = "data.xlsx", startDate, toDate) => {
  const formattedDateRange = `${startDate} - ${toDate}`;
  const headers = Object.keys(jsonData[0] || {});
  const colCount = headers.length;

  const worksheet = {};

  // 1. Set centered date in A1
  worksheet['A1'] = {
    t: 's',
    v: formattedDateRange,
    s: {
      font: { bold: true, sz: 20 },
      alignment: { horizontal: 'center' }
    }
  };

  // 2. Merge A1 across more columns (A to L or more for visual centering)
  worksheet['!merges'] = [
    { s: { r: 0, c: 0 }, e: { r: 0, c: 11 } } // A1 to L1
  ];

  // 3. Set column widths to ensure consistent layout
  worksheet['!cols'] = Array(12).fill({ wch: 20 }); // 12 columns, width ~20 chars

  // 4. Add spacing rows (rows 2–4)
  worksheet['!rows'] = [{ hpt: 24 }, {}, {}, {}];

  // 5. Insert data starting from A5
  const dataSheet = XLSX.utils.json_to_sheet(jsonData, { origin: 'A5' });

  // 6. Style header row (row 5)
  headers.forEach((key, index) => {
    const cellAddress = XLSX.utils.encode_cell({ r: 4, c: index }); // Row 5
    const cell = dataSheet[cellAddress];
    if (cell) {
      cell.v = String(cell.v).toUpperCase();
      cell.s = {
        font: { bold: true, color: { rgb: "FFFFFF" } },
        fill: { fgColor: { rgb: "000000" } },
        alignment: { horizontal: 'center' }
      };
    }
  });

  // 7. Merge both worksheets
  Object.assign(worksheet, dataSheet);

  // 8. Generate and download
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

  const buffer = XLSX.write(workbook, {
    bookType: 'xlsx',
    type: 'array',
    cellStyles: true
  });

  const file = new Blob([buffer], {
    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
  });

  saveAs(file, fileName);
};
